import { render, staticRenderFns } from "./Representative.vue?vue&type=template&id=1fdd5334&scoped=true&"
import script from "./Representative.vue?vue&type=script&lang=js&"
export * from "./Representative.vue?vue&type=script&lang=js&"
import style0 from "./Representative.vue?vue&type=style&index=0&id=1fdd5334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdd5334",
  null
  
)

export default component.exports